import { Injectable } from '@angular/core';
import { Moment } from 'moment';

@Injectable({
    providedIn: 'root'
})
export class DateTimeUtilsService {

    constructor() { }

    /**
     * Convert given date into a format favourable for backend. Conversion will returns
     * date as a string without timezone information
     */
    public convertDateFormBackend(date: Date): string {
        return date ? date.toString().split(" GMT")[0] : null;
    }

    /**
     * Convert given date into a format favourable for backend. Conversion will returns
     * date as a string without timezone information
     */
    public convertMomentFormBackend(date: Moment): string {
        return date ? this.convertDateFormBackend(date.toDate()) : null;
    }
}
